import script from "./UserPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPage.vue?vue&type=script&setup=true&lang=js"

export default script